import fetch from './fetch'

export const sayHello = async () => fetch(`/api/v1/hello`)

export const loginAdmin = async (mobile, password) => fetch(`/api/v1/admin/users/login`, { mobile, password }, 'POST')

export const getBooksByPage = async pagination => fetch(`/api/v1/admin/getbypage/books`, { ...pagination, items: [] }, 'POST')

export const getLinkRanksByPage = async pagination => fetch(`/api/v1/admin/getbypage/links`, { ...pagination, items: [] }, 'POST')

export const getUsersByPage = async pagination => fetch(`/api/v1/admin/getbypage/users`, { ...pagination, items: [] }, 'POST')

export const getCommentsByPage = async pagination => fetch(`/api/v1/admin/getbypage/comments`, { ...pagination, items: [] }, 'POST')

export const enableComment = async id => fetch(`/api/v1/admin/comments/${id}/enable`, null, 'POST')

export const disableComment = async id => fetch(`/api/v1/admin/comments/${id}/disable`, null, 'POST')

export const getKeywordsByPage = async pagination => fetch(`/api/v1/admin/getbypage/keywords`, { ...pagination, items: [] }, 'POST')

export const deleteKeyword = async id => fetch(`/api/v1/admin/keywords/delete/${id}`, null, 'POST')

export const addKeyword = async keyword => fetch(`/api/v1/admin/keywords/add`, { keyword }, 'POST')

export const getSummary = async () => fetch(`/api/v1/admin/summary`)

export const getMyUserInfo = async () => fetch(`/api/v1/admin/myuserinfo`)

export const updateMyPassword = async (oldPassword, newPassword) => fetch(`/api/v1/admin/updatemypassword`, { oldPassword, newPassword }, 'POST')

export const setAdmin = async userID => fetch(`/api/v1/admin/users/setadmin/${userID}`, null, 'POST')

export const unsetAdmin = async userID => fetch(`/api/v1/admin/users/unsetadmin/${userID}`, null, 'POST')
